import React from "react";
import { Link } from "react-router-dom";
import { useShopInfoStore } from "../../store";
import { observer } from "mobx-react-lite";
import { Popover, Spin } from "antd";
import classNames from "classnames";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import CountValue from "../../CountValue";

interface EwaybillAreaProps {}

const EwaybillArea: React.FC<EwaybillAreaProps> = function (props) {
    const store = useShopInfoStore();

    const allocatedQuantityCount = store.getCount(store.yesterdayAllocatedQuantity);
    const canceledQuantityCount = store.getCount(store.yesterdayCanceledQuantity);

    const allocatedQuantityCountEl = (
        <div className={classNames("count", allocatedQuantityCount === store.NoStatistics && "error")}>
            <CountValue value={allocatedQuantityCount} />
        </div>
    );

    const canceledQuantityCountEl = (
        <div className={classNames("count", canceledQuantityCount === store.NoStatistics && "error")}>
            <CountValue value={canceledQuantityCount} />
        </div>
    );

    const loading = store.waybillStatLoading;

    return (
        <div className="ewaybill-area">
            <div className="ewaybill-area-item">
                <Popover content="已开启运单号统计的店铺和网点，昨日打印的电子面单号">
                    <div className="title">昨日打印单号</div>
                </Popover>

                {allocatedQuantityCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>昨日无运单号统计数据，如要查看数据可前往开启</span>
                                <Link to="/features/waybillStatistics" className="ml5">
                                    去开启
                                </Link>
                            </div>
                        }
                    >
                        {allocatedQuantityCountEl}
                    </Popover>
                ) : (
                    allocatedQuantityCountEl
                )}
            </div>
            <div className="ewaybill-area-item">
                <Popover content="已开启运单号统计的店铺和网点，昨日回收的电子面单号">
                    <div className="title">昨日回收单号</div>
                </Popover>

                {canceledQuantityCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>昨日无运单号统计数据，如要查看数据可前往开启</span>
                                <Link to="/features/waybillStatistics" className="ml5">
                                    去开启
                                </Link>
                            </div>
                        }
                    >
                        {canceledQuantityCountEl}
                    </Popover>
                ) : (
                    canceledQuantityCountEl
                )}
            </div>

            <Link
                to="/features/waybillStatistics"
                className="operation"
                onClick={() => {
                    collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
                        content: "查看单号统计",
                    });
                }}
            >
                查看单号统计
            </Link>
        </div>
    );
};

export default observer(EwaybillArea);
